/* 🤖 this file was generated by svg-to-ts */
export const matIconTextIncrease: {
  name: 'text-increase';
  data: string;
} = {
  name: 'text-increase',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M.99 19h2.42l1.27-3.58h5.65L11.59 19h2.42L8.75 5h-2.5L.99 19zm4.42-5.61L7.44 7.6h.12l2.03 5.79H5.41zM20 11h3v2h-3v3h-2v-3h-3v-2h3V8h2v3z"/></svg>`
};
